import moment from 'moment'
let obj = {
    week() {
        let startMonth = moment().startOf('week').format('MM') - 0
        let startDay = moment().startOf('week').format('DD') - 0
        let endMonth = moment().subtract(1, 'days').format('MM') - 0
        let endDay = moment().subtract(1, 'days').format('DD') - 0

        if (startMonth == endMonth) {
            if (startDay > endDay) {
                return false
            }

        } else if (startMonth > endMonth) {
            return false
        }
        let startTime = moment().startOf('week').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    month() {
        let startMonth = moment().startOf('month').format('MM') - 0
        let startDay = moment().startOf('month').format('DD') - 0
        let endMonth = moment().subtract(1, 'days').format('MM') - 0
        let endDay = moment().subtract(1, 'days').format('DD') - 0

        if (startMonth != endMonth) {
            return false

        }
        let startTime = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    year() {
        let startYear = moment().startOf('year').format('YYYY') - 0
        let endYear = moment().subtract(1, 'days').format('YYYY') - 0

        if (startYear != endYear) {
            return false
        }
        let startTime = moment().startOf('year').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    day() {
        let startYear = moment().startOf('year').format('YYYY') - 0
        let endYear = moment().subtract(1, 'days').format('YYYY') - 0

        if (startYear != endYear) {
            return false
        }
        let startTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    nowWeek() {
        let startTime = moment().startOf('week').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    nowMonth() {
        let startTime = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    nowYear() {
        let startTime = moment().startOf('year').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    yestoday() {
        let startTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },
    today() {
        let startTime = moment().format('YYYY-MM-DD') + ' 00:00:00'
        let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59'
        return [startTime, endTime]
    },

    lastMonth() {
        let startTime = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD') + ' 00:00:00';
        let endTime = moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD') + ' 23:59:59';
        return [startTime, endTime]
    }
}

export default obj